import type {Api} from '../../core/lib/api/api';

/** Two consecutive successful non-pending polls confirm callback completion. */
export function monitorCallbackCompletion({
  fetchStatus,
  onComplete,
}: {
  fetchStatus: () => ReturnType<Api['fetchRequestACallCodes']>;
  onComplete: () => void;
}): () => void {
  let stopped = false;
  let consecutiveNonPendingPolls = 0;
  let timer: ReturnType<typeof setTimeout> | undefined;
  const stop = () => {
    stopped = true;
    clearTimeout(timer);
  };
  const poll = async () => {
    let delay = 5_000;
    try {
      const response = await fetchStatus();
      if (stopped) {
        return;
      }
      if (response.type === 'success') {
        consecutiveNonPendingPolls = response.pending
          ? 0
          : consecutiveNonPendingPolls + 1;
        if (consecutiveNonPendingPolls >= 2) {
          stop();
          onComplete();
          return;
        }
        if (response.nextReload && response.nextReload > 0) {
          delay = Math.min(response.nextReload * 1000, delay);
        }
      } else {
        consecutiveNonPendingPolls = 0;
      }
    } catch {
      // A failed poll is not completion evidence; retry until stopped.
      consecutiveNonPendingPolls = 0;
    }
    if (!stopped) {
      timer = setTimeout(poll, delay);
    }
  };
  poll();
  return stop;
}
